import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import view from "./view";

const Stats = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/:id`} component={view}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default Stats;
